<template>
  <div class="apply-cash-success">
    <div class="success-container">
      <div>
        <div class="result-icon" :class="isSuccess ? 'result-success' : 'result-error'"></div>
        <span class="color-333 size-18">{{
          isSuccess
            ? $t('您已发起{amount}元提现申请！', { amount: amount })
            : $t('抱歉，您发起的{amount}元提现申请失败了！', { amount: amount })
        }}</span>
      </div>
      <div class="color-666 size-14 margin-top-8">
        {{ isSuccess ? $t('e签宝将在2~3个工作日内处理您的提现申请，提现结果可登录钱包页面查看或及时查收短信。') : reason }}
      </div>
    </div>
    <div class="footer margin-top-20">
      <es-button type="primary" @click="goBack" class="margin-auto">{{ isSuccess ? $t('返回') : $t('重新申请') }}</es-button>
      <div class="text-center color-999 size-12 margin-top-80">
        {{ $t('提示：如相应资金长时间未到账，请咨询相关银行或拨打客服热线：400-087-8198。') }}
      </div>
    </div>
  </div>
</template>
<script>
import '@/assets/css/common.css'
export default {
  props: {
    success: {
      type: Boolean,
      default: false,
    },
    amount: {
      type: String,
      default: '',
    },
  },
  components: {},
  data() {
    return {
      isSuccess: this.success,
      reason: ``,
    }
  },
  methods: {
    goBack() {
      this.$router.push({
        path: '/MyWallet',
      })
    },
  },
}
</script>
<style lang="less" scoped>
.apply-cash-success {
  width: 1200px;
  margin: 0 auto;

  .footer {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
}

.success-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 136px;

  .result-icon {
    width: 40px;
    height: 40px;
    background-repeat: no-repeat;
    background-size: 100%;
    margin: 0 auto 18px;
  }

  .result-error {
    background-image: url('../../assets/use/error.png');
  }

  .result-success {
    background-image: url('../../assets/use/success.png');
  }
}
</style>
